@if (message) {
  <div class="message">
    <span>{{ message }}</span>
  </div>
}
